/** Mi Espacio: la bandeja de trabajo del usuario. */
import { apiFetch } from "./client";

export interface ItemBandeja {
  cita_id: number | null;
  asignacion_id: number | null;
  /** La petición de cita que hizo el paciente desde su app. */
  solicitud_id?: number | null;
  /** Receta pendiente de despachar (bandeja de farmacia). */
  receta_id: number | null;
  /** Plan con sesiones sin hora (bandeja de quien agenda). */
  plan_id: number | null;
  /** Orden de laboratorio (bandejas de caja, laboratorio y del médico). */
  orden_lab_id: number | null;
  paciente_id: number;
  paciente_nombre: string;
  titulo: string;
  detalle: string;
  inicio: string | null;
  monto: string | null;
  atrasada: boolean;
  /** Triaje de esta atención, si ya se tomó. */
  triaje_id: number | null;
  nivel_urgencia: number | null;
  signos: string | null;
  motivo: string | null;
}

export interface Bandeja {
  codigo:
    | "cobrar"
    | "triaje"
    | "atender"
    | "agendar"
    | "dispensar"
    /** Lo recetado que la farmacia no tenía: la lista de compra real. */
    | "reponer"
    | "agendar_sesiones"
    // Tres bandejas sobre la misma orden porque son tres trabajos: cobrarla,
    // procesarla y leer el resultado.
    | "lab_cobrar"
    | "lab_procesar"
    /** Exámenes que ocupan equipo y necesitan hora de admisión. */
    | "lab_agendar"
    | "lab_resultados";
  titulo: string;
  descripcion: string;
  total: number;
  items: ItemBandeja[];
  /** Lo primero que caerá aquí cuando llegue su día. Solo si la bandeja está vacía. */
  proximo: ItemBandeja | null;
}

export interface MiEspacio {
  bandejas: Bandeja[];
  total_pendiente: number;
}

export function getMiEspacio(): Promise<MiEspacio> {
  return apiFetch<MiEspacio>("/v1/mi-espacio");
}
